import {
  Badge,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from 'react'

const DevelopersCard = ({props}) => {
    console.log(props);
  return (
    <Center py={6}>
      <Stack
        borderWidth="1px"
        borderRadius="lg"
        w={{ sm: "100%", md: "540px" }}
        height={{ sm: "476px", md: "20rem" }}
        direction={{ base: "column", md: "row" }}
        boxShadow={"2xl"}
        padding={4}
      >
        <Flex flex={1} bg="blue.200">
          <Image
            objectFit="cover"
            boxSize="100%"
            src={`https://missionlife.iiita.ac.in//${props?.avatar_url}`}
          />
        </Flex>
        <Stack
          flex={1}
          flexDirection="column"
          justifyContent="space-around"
          alignItems="flex-start"
          p={1}
          pt={2}
        >
          <Stack
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
          >
            <Heading fontSize={"2rem"} fontFamily={"body"}>
              {props?.username}
            </Heading>
          </Stack>
          {/* <Text fontWeight={600} color={"gray.500"} size="sm" mb={4}>
            @lindsey_jam3s
          </Text> */}
          <Stack align={"flex-start"} justify={"center"} direction={"column"} mt={6}>
            <Badge px={2} py={1} fontWeight={"500"}>
              Github: <a target="_blank" href={props?.profile_links}>{props?.profile_links.slice(props?.profile_links.lastIndexOf("/")+1)}</a>
            </Badge>
            <Badge px={2} py={1} fontWeight={"500"}>
              Email: {props?.email}
            </Badge>
            <Badge px={2} py={1} fontWeight={"500"}>
              Worked Time: {`${props?.worked_month}, ${props?.worked_year}`}
            </Badge>
          </Stack>

          {/* <Stack
            width={"100%"}
            mt={"2rem"}
            direction={"row"}
            padding={2}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Button
              flex={1}
              fontSize={"sm"}
              rounded={"full"}
              _focus={{
                bg: "gray.200",
              }}
            >
              Message
            </Button>
            <Button
              flex={1}
              fontSize={"sm"}
              rounded={"full"}
              bg={"blue.400"}
              color={"white"}
              boxShadow={
                "0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)"
              }
              _hover={{
                bg: "blue.500",
              }}
              _focus={{
                bg: "blue.500",
              }}
            >
              Follow
            </Button>
          </Stack> */}
        </Stack>
      </Stack>
    </Center>
  );
}

export default DevelopersCard